/**
 * ランキング・リーグに出す「なまえ」の決まり(docs/12_challenge_ranking.md §1)。
 *
 * **サーバー(`functions/src/challengeValidation.ts`)の写し**。
 * 権威はあくまでサーバーで、ここは
 *   - 送る前に画面でやさしく直せるようにする
 *   - 通らない値を送って往復ぶん待たせない
 * ためだけに置く。ずれたらサーバーが弾くので、遊びが壊れることは無い。
 *
 * ここは Firebase SDK も React も import しない純関数だけ(タイトル画面から
 * 読まれる `gameStore` が使うので、初期バンドルを太らせない)。
 */

/** なまえの長さ(**コードポイント数**。絵文字も1文字)。 */
export const DISPLAY_NAME_MAX = 10;

/**
 * まだ なまえを つけていない子の表示(`functions/src/challengeStore.ts` の
 * `DEFAULT_DISPLAY_NAME` と同じ)。順位表にはこの名前で出る。
 */
export const DEFAULT_DISPLAY_NAME = 'ぱるっこ';

/**
 * なまえに使えない文字(制御文字・書式制御・行区切り)。
 * 順位表の行を改行で壊したり、不可視文字で名前を偽装したりさせない。
 */
const FORBIDDEN_NAME_CHARS = /[\p{Cc}\p{Cf}\u2028\u2029]/u;

/** 前後の空白を落とす(全角スペースも `trim()` の対象)。 */
export function normalizeDisplayName(raw: string): string {
  return raw.trim();
}

/** 見た目の文字数(サロゲートペアを2と数えない)。 */
export function displayNameLength(raw: string): number {
  return [...raw].length;
}

/**
 * だめな理由(`null` = OK)。**そのまま画面に出す文言**なのでひらがな中心
 * (CLAUDE.md ルール5)。トリム前の生の入力をそのまま渡してよい。
 */
export function displayNameError(raw: string): string | null {
  const name = normalizeDisplayName(raw);
  if (displayNameLength(name) === 0) return 'なまえを いれてね';
  if (FORBIDDEN_NAME_CHARS.test(name)) return 'つかえない もじが はいっているよ';
  if (displayNameLength(name) > DISPLAY_NAME_MAX)
    return `なまえは ${DISPLAY_NAME_MAX}もじ までだよ`;
  return null;
}

/** 送ってよい形か。 */
export function isValidDisplayName(raw: string): boolean {
  return displayNameError(raw) === null;
}
